import Link from 'next/link';
import Router from 'next/router';
import React, { Component } from 'react';
import { Image } from 'react-img-webp';

import AlphabeticData from '../AlphabeticData';
import { collator } from '../Services';

class CategoryItems extends Component {
	render() {
		const { groupByAlphaFilter, SearchName, categoryIndex, categories, SortBy, shop } = this.props;

		var CategoryCount = categories.length ? categories.length : 0;

		return (
			<>
				{Object.keys(groupByAlphaFilter).length > 2 && CategoryCount > 15 ? (
					<div className="alphabetical-selection-group">
						<div className="alphabetical-selection-title">
							<h5>Jump To Your {SearchName ? SearchName : 'Item'} Quickly.</h5>
						</div>

						<div className="header mt-0">
							{Object.keys(groupByAlphaFilter).map(key => (
								<a className="letter" href={'#' + key} key={key}>
									{key}
								</a>
							))}
						</div>

						<div className="items">
							{Object.keys(groupByAlphaFilter).length > 0
								? Object.keys(groupByAlphaFilter).map(key => (
										<AlphabeticData
											data={groupByAlphaFilter[key]}
											keyName={key}
											categoryIndex={categoryIndex}
											key={key}
											collapsable={false}
										/>
								  ))
								: 'Loading'}
						</div>
					</div>
				) : (
					<div className="category-elements-group mt-3">
						<div className="category-elements-wrapper">
							{categories
								? categories // TODO: add Sort by Sort Order Here...  ( Check for NUll use 'category/vehicle-batteries-car-or-truck-dodge-ram-1500' as a Sample)
										.sort((a, b) => {
											if (SortBy === 'Asc') return collator.compare(a.name, b.name);
											else return collator.compare(b.name, a.name);
										})
										.sort((a, b) => {
											return b.sortOrder
												? b.sortOrder
												: 999999 < a.sortOrder
												? a.sortOrder
												: 999999;
										})
										.map((item, i) => {
											return (
												<div
													className={`category-element ${item.imageOnly ? 'image-only' : ''}`}
													key={i}
													onClick={() => {
														Router.push(
															`/category/[categoryid]?categoryid=${
																item.urlRedirect != null
																	? item.urlRedirect
																	: item.urlSlug
															}`,
															`/category/${
																item.urlRedirect != null
																	? item.urlRedirect
																	: item.urlSlug
															}`
														).then(() => window.scrollTo(0, 0));
													}}>
													<Link
														href={`/category/[categoryid]`}
														as={`/category/${
															item.urlRedirect != null ? item.urlRedirect : item.urlSlug
														}`}
														prefetch={false}>
														<a
															href={`/category/${
																item.urlRedirect != null
																	? item.urlRedirect
																	: item.urlSlug
															}`}>
															{item.imageUrl && this.props.showImages ? (
																<Image
																	objectFit="contain"
																	width="100px"
																	height="100px"
																	alt={item.name}
																	src={item.imageUrl}
																	webP={
																		item.imageUrl.substr(
																			0,
																			item.imageUrl.lastIndexOf('.') < 0
																				? item.imageUrl.length
																				: item.imageUrl.lastIndexOf('.')
																		) + '.webp'
																	}
																	className="lazyload"
																/>
															) : (
																''
															)}

															<h5 data-hover="size 06">
																{item.name}
															</h5>
														</a>
													</Link>
												</div>
											);
										})
								: 'Loading...'}
						</div>
					</div>
				)}
			</>
		);
	}
}

export default CategoryItems;
